import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { ProjectsService } from 'app/main/Services/projects.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
var EmailPreviewComponent = /** @class */ (function () {
    function EmailPreviewComponent(dialogRef, quote_data, projectsService, toastr, router, route, _formBuilder) {
        this.dialogRef = dialogRef;
        this.quote_data = quote_data;
        this.projectsService = projectsService;
        this.toastr = toastr;
        this.router = router;
        this.route = route;
        this._formBuilder = _formBuilder;
    }
    EmailPreviewComponent.prototype.Onclose = function () {
        this.dialogRef.close();
    };
    EmailPreviewComponent.prototype.ngOnInit = function () {
        this.project_id = this.route.snapshot.params['id'];
        this.config = {
            width: "1000px",
            height: '338px',
            toolbar: [
                { name: 'document', items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'] },
                { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
                { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'] },
                { name: 'forms', items: ['Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField'] },
                '/',
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language'] },
                { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                { name: 'insert', items: ['Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'] },
                '/',
                { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                { name: 'colors', items: ['TextColor', 'BGColor'] },
                { name: 'tools', items: ['Maximize', 'ShowBlocks'] },
                { name: 'about', items: ['About'] }
            ]
            // toolbar: [
            //     { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            //     { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat'] }
            // ]
        };
        this.Form = this._formBuilder.group({
            to: ['', Validators.compose([Validators.required, Validators.email])],
            cc: ['', Validators.compose([Validators.email])],
            bcc: ['contact@daytranslations.com', Validators.compose([Validators.email])],
            subject: ['', Validators.compose([Validators.required])],
            ckeditorContent: [''],
        });
        this.get_quote_email();
    };
    EmailPreviewComponent.prototype.updateMessage = function () {
        var _this = this;
        if (this.Form.value.subject == '') {
            this.toastr.error("Subject never be empty!!");
            return;
        }
        if (this.Form.value.ckeditorContent == '') {
            this.toastr.error("Body never be empty!!");
            return;
        }
        var data = {
            mail_response: {}
        };
        var mail_response = {
            to: '',
            cc: '',
            bcc: '',
            message: '',
            subject: '',
        };
        mail_response.to = this.Form.value.to;
        mail_response.cc = this.Form.value.cc;
        mail_response.bcc = this.Form.value.bcc;
        mail_response.message = this.Form.value.ckeditorContent;
        mail_response.subject = this.Form.value.subject;
        data = this.quote_data;
        data.mail_response = mail_response;
        this.projectsService.sendProjectQuote(data)
            .subscribe(function (response) {
            if (response) {
                _this.router.navigate(['/pms/project/details/' + _this.quote_data.project_id]);
                _this.toastr.success("Quote Created");
                _this.Onclose();
            }
        }, function (error) {
            _this.toastr.error(error.message);
        });
    };
    EmailPreviewComponent.prototype.get_quote_email = function () {
        var _this = this;
        this.projectsService.get_quote_email(this.quote_data)
            .subscribe(function (response) {
            if (response) {
                //   this.Form.value.ckeditorContent= response.mail_response.message;
                //  this.Form.value.subject=response.mail_response.subject;
                //  this.Form.value.to=response.mail_response.To;
                _this.Form.patchValue({
                    ckeditorContent: response.mail_response.message,
                    subject: response.mail_response.subject,
                    to: response.mail_response.To,
                });
            }
        }, function (error) {
            _this.toastr.error(error.message);
        });
    };
    return EmailPreviewComponent;
}());
export { EmailPreviewComponent };
